<div mat-dialog-title>
	<i class="material-icons linkable" aria-hidden="true" (click)="onNoClick();" style="float: right;">close</i>
	<h1>{{data.payModuleTitle}}</h1>
</div>
<div mat-dialog-content>
	<div name="ManualPayOptionsForm">
		<div class="row" *ngIf="data.clientPaymentProfile.processorId == cardProcessorTypes.Heartland">
			<div class="col col-12">
				<heartland-form [orderKey]="data.selectedOrderKey" [activeInvoice]="data.activeInvoice" [profile]="data.clientPaymentProfile" (closer)="data.activeInvoice = $event.invoiceModel; close({});"></heartland-form>
			</div>
		</div>
		<div class="row" *ngIf="data.clientPaymentProfile.processorId == cardProcessorTypes.MonerisCheckout">
			<div class="col col-12">
				<moneris-checkout-form [profile]="data.clientPaymentProfile" [selectedOrderKey]="data.selectedOrderKey" [orderRefNumber]="data.orderRefNumber" [clientKey]="invoiceService.getClientGuid()" (closer)="close($event);"></moneris-checkout-form>
			</div>
		</div>
		<div class="row" *ngIf="data.clientPaymentProfile?.processorId == cardProcessorTypes.CyberSource">
			<div class="col col-12">
				<cyber-source-form [profile]="data.clientPaymentProfile" [selectedOrderKey]="data.selectedOrderKey" [orderRefNumber]="data.orderRefNumber" [clientKey]="invoiceService.getClientGuid()" [orderAmount]="data.totalAmountDueInclTax" [email]="data.activeInvoice.email" (closer)="close($event);"></cyber-source-form>
			</div>
		</div>
	</div>
</div>